import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { ApolloProvider } from '@apollo/client';
import { MosaicProvider } from '@opendoor/mosaic';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

import VerticalLayout from './components/layouts/VerticalLayout';
import NavigationBar from './components/NavigationBar';
import ErrorBoundary from './contexts/ErrorBoundary';
import { SessionProvider } from './contexts/SessionContext';
import MaintenanceInvoicePage from './pages/MaintenanceInvoicePage';
import OnSiteWorkerProgress from './pages/OnSiteWorkerProgress';
import Profile from './pages/Profile';
import Visits from './pages/Visits';
import WorkOrderIndex from './pages/WorkOrderIndex';
import WorkOrderProgress from './pages/WorkOrderProgress';
import { clientFromUrl } from './setupAthenaClient';

const App = () => (
  <MosaicProvider themeVariant="v2">
    <ApolloProvider client={clientFromUrl()}>
      <VerticalLayout className="w-100% h-100% bg-white">
        <SessionProvider>
          <ErrorBoundary>
            <BrowserRouter>
              <QueryParamProvider adapter={ReactRouter6Adapter}>
                <NavigationBar />
                <Routes>
                  <Route path="/" element={<Profile />} />
                  <Route path="/visits" element={<Visits />} />
                  <Route path="/maintenance" element={<MaintenanceInvoicePage />} />
                  <Route path="/work-orders" element={<WorkOrderIndex />} />
                  <Route
                    path="/work-orders/:workOrderId/progress"
                    element={<WorkOrderProgress />}
                  />
                  <Route
                    path="/on-site/work-requests/work-order/:workOrderId/progress"
                    element={<OnSiteWorkerProgress />}
                  />
                </Routes>
              </QueryParamProvider>
            </BrowserRouter>
          </ErrorBoundary>
        </SessionProvider>
      </VerticalLayout>
    </ApolloProvider>
  </MosaicProvider>
);

export default App;
